export default __webpack_public_path__ + "static/media/mitigation-water-damage-window-wall.923c3a8f.jpg";